<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="page-header">
                        <div class="d-flex">
                            <div>
                                <button type="button"
                                    class="btn size btn-primary btn-icon-text floatright mt-1"
                                    (click)="Back()">
                                    <span style="display: contents; align-items: center;">
                                        <img width="20vh" src="../../assets/img/turn-left.gif"
                                            style="margin-right: 5px;">
                                        Back
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row row-sm add-form mt-4" >
                        <head>
                            <meta charset="UTF-8">
                            <meta name="viewport" content="width=device-width, initial-scale=1.0">
                            <title>Transfer Certificate Sample</title>
                            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/css/bootstrap.min.css" rel="stylesheet">
                            <style>
                                body {
                                    font-family: Arial, sans-serif;
                                    background-color: #f8f9fa;
                                    padding: 20px;
                                    
                                }
                                .container {
                                    background-color: #fff;
                                    padding: 30px;
                                    border-radius: 8px;
                                    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
                                    border: 1px,solid,black
                                }
                                h1 {
                                    text-align: center;
                                    text-decoration: underline;
                                    margin-bottom: 30px;
                                }
                                label {
                                    font-weight: bold;
                                }
                                .form-group {
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 20px;
                                }
                                .form-control-underline {
                                    border: none;
                                    border-bottom: 1px solid #000;
                                    border-radius: 0;
                                    background: transparent;
                                    width: 100%;
                                }
                                .form-control-underline:focus {
                                    box-shadow: none;
                                    border-color: #000;
                                }
                                .signature {
                                    margin-top: 30px;
                                }
                                .signature div {
                                    text-align: center;
                                }
                                ul {
                                    padding-left: 20px;
                                }
                            </style>
                        </head>
                        <body>
                        
                            <div class="container">
                                <h1>{{Certificate}} Sample</h1>
                        
                               
                                <p>Parents while seeking admission must submit the Transfer Certificate from the last school attended in the format below and should be on the original letterhead of the leaving school.</p>
                        
                                <ul>
                                    <li>Complete the form as of the student’s last day in attendance on his/her school letterhead</li>
                                    <li>This form must be signed and stamped by a school official (blue ink preferred)</li>
                                    <li>The Original Transfer Certificate must be presented on or before the first day of school at EISM</li>
                                    <li>An original Transfer Certificate is required by the UAE Ministry of Education from Year 3 & above</li>
                                </ul>
                        
                                <form>
                                    <div class="form-group">
                                        <label for="student_name" class="me-3">Name of Student:</label>
                                        <input type="text" class="form-control form-control-underline" id="student_name" placeholder="Enter student name">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="nationality" class="me-3">Nationality:</label>
                                        <input type="text" class="form-control form-control-underline" id="nationality" placeholder="Enter nationality">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="dob" class="me-3">Date of Birth (dd/mm/YY):</label>
                                        <input type="text" class="form-control form-control-underline" id="dob" placeholder="Enter date of birth">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="admitted_class" class="me-3">Class to which admitted:</label>
                                        <input type="text" class="form-control form-control-underline" id="admitted_class" placeholder="Enter admitted class">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="admitted_year" class="me-3">Academic Year:</label>
                                        <input type="text" class="form-control form-control-underline" id="admitted_year" placeholder="Enter academic year">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="present_class" class="me-3">Present Class:</label>
                                        <input type="text" class="form-control form-control-underline" id="present_class" placeholder="Enter present class">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="last_attendance_date" class="me-3">Last date of attendance:</label>
                                        <input type="text" class="form-control form-control-underline" id="last_attendance_date" placeholder="Enter last date of attendance">
                                    </div>
                        
                                    <div class="form-group">
                                        <label class="me-3">Result at the end of academic year:</label>
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="promoted_class" class="me-3">a) Promoted to class:</label>
                                        <input type="text" class="form-control form-control-underline" id="promoted_class" placeholder="Enter promoted class">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="promoted_year" class="me-3">Academic Year:</label>
                                        <input type="text" class="form-control form-control-underline" id="promoted_year" placeholder="Enter academic year">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="detained_class" class="me-3">b) Detained in class:</label>
                                        <input type="text" class="form-control form-control-underline" id="detained_class" placeholder="Enter detained class">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="detained_year" class="me-3">Academic Year:</label>
                                        <input type="text" class="form-control form-control-underline" id="detained_year" placeholder="Enter academic year">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="observation" class="me-3">Observation (if any):</label>
                                        <input type="text" class="form-control form-control-underline" id="observation" placeholder="Enter observation">
                                    </div>
                        
                                    <div class="form-group">
                                        <label for="school_system" class="me-3">School System:</label>
                                        <input type="text" class="form-control form-control-underline" id="school_system" placeholder="12 Year or 13 Year system study">
                                    </div>
                        
                                    <div class="signature row">
                                        <div class="col-md-6">
                                            <p>Headmaster/Principal/Director of school</p>
                                            <p>Name: _______________________________</p>
                                            <p>Signature: ___________________________</p>
                                        </div>
                                        <div class="col-md-6">
                                            <p>School Stamp</p>
                                        </div>
                                    </div>
                                </form>
                        
                                <p>Except for American, Canadian and European countries, the Original Transfer Certificate (TC) must be signed by:</p>
                                <ul>
                                    <li>Ministry of Education (Country of TC Origin)</li>
                                    <li>Ministry of Foreign Affairs (Country of TC Origin)</li>
                                    <li>UAE Embassy (Country of TC Origin)</li>
                                </ul>
                            </div>
                        
                            <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0-alpha1/dist/js/bootstrap.bundle.min.js"></script>
                        </body>
                   </div>
                    
                    
                </div>
            </div>
        </div>
    </form>
</body>




























<!-- 
<!DOCTYPE html>
<html lang="en">

</html> -->
